// Subscriptions Management Permissions

export const SUBSCRIPTIONS_INDEX = 131;
